import '@styles/pages/offer-page.scss';

import { initCarousel } from '@molecules/carousel';
import { initOfferCard } from '@molecules/components/offer-card';
import { initSelectionBusHandler } from '@molecules/selection-bus-handler';
import { selectionSliderManager } from '@molecules/selection-slider-manager';
import { initStaticGoogleMap } from '@molecules/static-google-map';
import { initGallery } from '@organisms/gallery';
import { initOfferStateModals } from '@organisms/offer/offer-state-modals';
import { calendly } from '@pages/offer-page/calendly';
import { combinator } from '@pages/offer-page/combinator';
import { description } from '@pages/offer-page/description';
import { offerDetails } from '@pages/offer-page/details';
import { offerNavbar } from '@pages/offer-page/navbar';
import { officeChooser } from '@pages/offer-page/office-chooser';
import { officeConfiguratorLauncher } from '@pages/offer-page/office-configurator-launcher';
import { onlineStatus } from '@pages/offer-page/online-status';
import { otherOffers } from '@pages/offer-page/other-offers';
import { seenOffers } from '@pages/offer-page/seen-offers';
import { selection } from '@pages/offer-page/selection';
import { share } from '@pages/offer-page/share';
import { staticMap } from '@pages/offer-page/static-map';
import { statistics } from '@pages/offer-page/statistics';
import { virtualVisit } from '@pages/offer-page/virtual-visit';

officeConfiguratorLauncher();
offerDetails();
description();
staticMap();
seenOffers();
virtualVisit();
combinator();
otherOffers();
onlineStatus();
initOfferStateModals();
share();
offerNavbar();
initCarousel();
officeChooser();
initStaticGoogleMap();
selection();
statistics();
calendly();
initGallery();
initOfferCard();
initSelectionBusHandler();
selectionSliderManager();
